import { gql, TypedDocumentNode } from "@apollo/client";

import { PolicySimulateInput } from "types/generated";

const attachedPolicyFragment = gql`
  fragment attachedPolicy on StackPolicyAttachment {
    id
    policyId
    policyName
    policyType
    policyBody
    policyLabels
    isAutoattached
  }
`;

export const GET_STACK_ATTACHED_POLICIES = gql`
  query GetStackAttachedPolicies($entityId: ID!) {
    entity: stack(id: $entityId) {
      attachedPolicies {
        ...attachedPolicy
      }
    }
  }
  ${attachedPolicyFragment}
`;

export const GET_MODULE_ATTACHED_POLICIES = gql`
  query GetModuleAttachedPolicies($entityId: ID!) {
    entity: module(id: $entityId) {
      attachedPolicies {
        ...attachedPolicy
      }
    }
  }
  ${attachedPolicyFragment}
`;

export const GET_ATTACHABLE_POLICIES_IN_SPACE = gql`
  query GetAttachablePoliciesInSpace($spaceId: ID!) {
    attachablePoliciesInSpace(id: $spaceId) {
      id
      name
      type
    }
  }
`;

export const ATTACH_POLICY_TO_ENTITY = gql`
  mutation AttachPolicyToEntity($policyId: ID!, $entityId: ID!) {
    policyAttach(id: $policyId, stack: $entityId) {
      id
    }
  }
`;

export const DETACH_POLICY_FROM_ENTITY = gql`
  mutation DetachPolicyFromEntity($attachmentId: ID!) {
    policyDetach(id: $attachmentId) {
      id
    }
  }
`;

/* eslint-disable @cspell/spellchecker */
export const SIMULATE_POLICY_V2: TypedDocumentNode<
  { policySimulatev2: string },
  { input: PolicySimulateInput }
> = gql`
  mutation SimulatePolicyV2($input: PolicySimulateInput!) {
    policySimulatev2(input: $input)
  }
`;
/* eslint-enable @cspell/spellchecker */